import React, { useState } from 'react'
import { Image, ModalComponent, VideoOverlay, Link } from 'newComponents'
import CtaArrow from '../../../components/ctaArrow'

const TwoColVideo = (prop) => {
  const { item } = prop
  const [modalOpen, setModalOpen] = useState(false)
  const videoTitle = item.title?.text
  const videoContent = item.content?.html
  const videoId = item.video_id
  const image = item.main_placeholder_image
  const avatar = item.quote_speaker_avatar
  const speakerName = item.quote_speaker_name
  const speakerPosition = item.quote_speaker_position
  const ctaText = item.cta_link_text
  const ctaUrl = item.cta_link_url
  const { icon } = item

  const toggleVideoModal = (e) => {
    e.preventDefault()
    setModalOpen(!modalOpen)
  }

  return (
    <>
      <div className="two-column-image-text-repeater-container">
        <div className="two-column-image-text-repeater-container-left">
          {icon && <Image className="feature-block-slice-image" image={icon} />}
          <h3>{videoTitle}</h3>
          <div className="video-text-content" dangerouslySetInnerHTML={{ __html: videoContent }} />
          {speakerName.text && (
            <div className="video-quote-info">
              <div className="video-quote-info-avatar">
                <Image image={avatar} />
              </div>
              <div className="video-quote-info-detail">
                <p className="video-quote-info-name">{speakerName.text}</p>
                <p className="video-quote-info-position">{speakerPosition.text}</p>
              </div>
            </div>
          )}
          {ctaUrl.url && (
            <Link className="video-text-content-link" to={ctaUrl.url}>
              {ctaText.text} <CtaArrow />
            </Link>
          )}
          {videoId && (
            <a className="video-trigger-btn" onClick={toggleVideoModal}>
              Watch Video <CtaArrow />
            </a>
          )}
        </div>
        <div className="two-column-image-text-repeater-container-right">
          <Image className="two-columns-video" image={image} />
          {videoId && <VideoOverlay toggleVideoModal={toggleVideoModal} />}
        </div>
      </div>
      {videoId && (
        <ModalComponent modalOpen={modalOpen} toggleModal={toggleVideoModal}>
          <div className="modal-content-video">
            <div className="section">
              <iframe
                title="LaunchDarkly testimonial by HoneyComb"
                src={`https://www.youtube.com/embed/${videoId}`}
                width="100%"
                height="100%"
                frameBorder="0"
                allow="autoplay; fullscreen"
                allowFullScreen
              />
            </div>
          </div>
        </ModalComponent>
      )}
    </>
  )
}

export default TwoColVideo
